/* tslint:disable */
/* eslint-disable */
/**
 * V2M Backend API
 * Backend API for the V2M multi-brand platform (word2mail, koe2mail, sprich2mail, ...) - handles authentication, quota management, and LLM requests
 *
 * The version of the OpenAPI document: 1.0.5
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the EmailQuotaStatus interface.
 */
export function instanceOfEmailQuotaStatus(value) {
    if (!('bulkAvailable' in value) || value['bulkAvailable'] === undefined)
        return false;
    if (!('bulkSent' in value) || value['bulkSent'] === undefined)
        return false;
    if (!('totalSent' in value) || value['totalSent'] === undefined)
        return false;
    if (!('transactionalAvailable' in value) || value['transactionalAvailable'] === undefined)
        return false;
    if (!('transactionalSent' in value) || value['transactionalSent'] === undefined)
        return false;
    return true;
}
export function EmailQuotaStatusFromJSON(json) {
    return EmailQuotaStatusFromJSONTyped(json, false);
}
export function EmailQuotaStatusFromJSONTyped(json, _ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'bulkAvailable': json['bulk_available'],
        'bulkSent': json['bulk_sent'],
        'totalSent': json['total_sent'],
        'transactionalAvailable': json['transactional_available'],
        'transactionalSent': json['transactional_sent'],
    };
}
export function EmailQuotaStatusToJSON(json) {
    return EmailQuotaStatusToJSONTyped(json, false);
}
export function EmailQuotaStatusToJSONTyped(value, _ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'bulk_available': value['bulkAvailable'],
        'bulk_sent': value['bulkSent'],
        'total_sent': value['totalSent'],
        'transactional_available': value['transactionalAvailable'],
        'transactional_sent': value['transactionalSent'],
    };
}
